<!--
	{
		"data": {
			"ptmmFullName": "Thomas Hendri Hananto",
			"ptmmEmail": "foxdove02@gmail.com",
			"ptmmPhone": "085329688884",
			"ptmmGender": 1,
			"ptmmPassword": "sa"
		}
	}
-->

<template>
	<b-container fluid class="signinForm">
		<b-row>
			<b-col md="12">
				<div class="sign">
				<div class="logo"></div>
				<h3 class="text-center">{{ $t("signup.head") }}</h3>
				<div class="welform">

					<div class="invitation" v-if="showInvitation">
						<div v-if="!invitationSent">
							<svg-image image="iconNew"/>
							<div v-html="$t('signup.form.invitation.head')"></div>
							<b-button block :disabled="loading" @click.prevent="useOldData"><b-spinner v-if="loading" small></b-spinner>{{ $t("signup.form.invitation.reuse") }}</b-button>
							<div v-html="$t('signup.form.separator')"></div>
							<b-button block :disabled="loading" @click.prevent="daleteOldData"><b-spinner v-if="loading" small></b-spinner>{{ $t("signup.form.invitation.new") }}</b-button>
							<div v-html="$t('signup.agree')"></div>
						</div>
						<div v-else>
							<hr/>
								<div class="successAlert">
								<svg-image image="iconEnvelope"/>
								<h6 class="text-center">{{ $t("signup.form.invitation.sent.label") }}</h6>
								<p class="text-center">{{ $t("signup.form.invitation.sent.desc") }}</p>
								</div>
							<hr/>
						</div>
						<alert :status="status"/>
					</div>

					<b-form @submit="onOtp" @resend="resendOtp" v-if="showOtp">
						<hr/>
						<div class="otpAlert">
						<svg-image image="iconOTP"/>
						<h6 class="text-center">{{ $t("signup.otp.label") }}</h6>
						<p class="text-center">{{ $t("signup.otp.desc") }}</p>
						</div>
						<hr/>
						<b-form-group id="otp-group"
							:label="$t('signup.otp.form')"
							label-for="otp"
						>
							<b-form-input
								id="otp"
								v-model="formOtp.otpCode"
								type="number"
								required
								:state="formOtpStatus.otpCode.state"
							></b-form-input>
							<b-form-invalid-feedback :state="formOtpStatus.otpCode.state">
								{{formOtpStatus.otpCode.message}}
							</b-form-invalid-feedback>
							<b-form-valid-feedback :state="formOtpStatus.otpCode.state">
								{{formOtpStatus.otpCode.message}}
							</b-form-valid-feedback>
						</b-form-group>
						<alert :status="status"/>
						<div class="clearfix">
							<!-- <b-button to="/signup" variant="danger">Back</b-button> -->
							<!-- <b-button class="float-left" type="resend" variant="danger">Resend OTP</b-button> -->
							<b-button class="float-right" type="submit" block variant="outline-primary" size="lg" :disabled="loading"><b-spinner v-if="loading" small></b-spinner> {{ $t("signup.otp.btn") }}</b-button>
						</div>
					</b-form>

					<b-form @submit="onSubmit" @reset="onReset" v-if="showForm">
						<b-form-group id="email-group"
							:label="$t('signup.form.email')"
							label-for="email"
							description=""
						>
							<b-input-group>
								<b-form-input
									id="email"
									v-model="form.ptmmEmail"
									type="email"
									required
									placeholder=""
									:state="emailState.state"
									:disabled="checkingEmail||emailChecked"
									@change="emailChanged"
								></b-form-input>
								<b-input-group-append v-if="showCheckButton">
									<b-button variant="primary" :disabled="checkingEmail" @click="checkEmail">
										<b-spinner v-if="checkingEmail" small></b-spinner>
										<b-icon v-if="!checkingEmail" icon="search"></b-icon><span> {{ $t("signup.form.check") }}</span>
									</b-button>
								</b-input-group-append>
								<!-- <b-spinner v-if="checkingEmail" medium type="grow"></b-spinner> -->
							</b-input-group>
							<b-form-invalid-feedback :state="emailState.state">
								{{emailState.message}}
							</b-form-invalid-feedback>
							<b-form-valid-feedback :state="emailState.state">
								{{emailState.message}}
							</b-form-valid-feedback>
						</b-form-group>
						<div v-if="emailInUSe" class="text-center">
							<div v-html="$t('signup.form.used')"></div>
							<a class="resendBtn" @click="resendVerificationEmail" type="resend" :disabled="resendingEmail">{{$t('signup.form.resendCode')}}</a>.
							<!-- <h6>This e-mail address has been registered before.</h6>
							<p>If you've successfully registered before, <a href="/signin">proceed to sign in page</a>.</p>
							<div class="separator"><p class="center-line"><span>or</span></p></div>
							<p>If you've not verify this e-mail address, <a class="resend" @click="resendVerificationEmail" type="resend" :disabled="resendingEmail">resend the verification code</a>.</p>
							 -->
							<!-- <ul>
								<li>
									<b-button to="/signin" variant="success">If you've ever registered before Click here to proceed to login page</b-button>
								</li>
								<li>
									<b-button class="mt-2" @click="resendVerificationEmail" type="resend" variant="warning" :disabled="resendingEmail">If you submit but no verification email yet, click here to resend</b-button>
								</li>
								<li>
									<b-button class="mt-2" type="reset" variant="danger">If you want to use another email, click here</b-button>
								</li>
							</ul> -->
						</div>

						<div v-if="emailChecked">

							<b-form-group id="name-group" :label="$t('signup.form.name')" label-for="name" :description="$t('signup.form.named')">
								<b-form-input
									id="name"
									v-model="form.ptmmFullName"
									required
								></b-form-input>
							</b-form-group>

							<b-form-group id="gender-group" :label="$t('signup.form.gender')" label-for="gender">
								<b-form-select
									id="gender"
									v-model="form.ptmmGender"
									:options="gender"
									required
								></b-form-select>
							</b-form-group>

							<!--<b-form-group id="language-group" label="Language " label-for="language">
								<b-form-select
									id="language"
									v-model="form.ptmmLanguage"
									:options="languages"
									required
								></b-form-select>
							</b-form-group>-->

							<!-- <b-form-group id="phone-group" label="Your Phone Number:" label-for="phone">
								<VuePhoneNumberInput required v-model="form_.phone" default-country-code="ID" @update="phoneUpdated"/>
							</b-form-group> -->

							<b-form-group id="password-group"
								:label="$t('signup.form.pwd')"
								label-for="password"
							>
								<b-input-group>
									<b-form-input
										id="password"
										v-model="form.ptmmPassword"
										:class='{valid:passwordValidation.valid}' 
										:type="passwordVisible ? 'text' : 'password'"
										required
										:placeholder="$t('signup.form.pwdplace')"
										:state="passwordChecker"
									></b-form-input>
									<b-input-group-append>
										<b-button class="hideandseek" variant="info" @click='togglePasswordVisibility' :arial-label='passwordVisible ? "Hide password" : "Show password"'><b-icon :icon='passwordVisible ? "eye-slash-fill" : "eye-fill"'></b-icon></b-button>
									</b-input-group-append>			
								</b-input-group>				
								<b-form-input
									id="checkPassword"
									v-model.lazy='checkPassword'
									type="password"
									required
									:placeholder="$t('signup.form.rpwdplace')"
									:state="passwordChecker"
									class="mt-2"
								></b-form-input>
								<b-form-invalid-feedback :state="passwordChecker">
									<ul>
										<li v-for='error in passwordValidation.errors'>{{error}}</li>
										<li v-if="notSamePasswords">{{ $t("signup.form.errmsg5") }}</li>
									</ul>
								</b-form-invalid-feedback>
								<b-form-valid-feedback :state="passwordChecker">
								</b-form-valid-feedback>
							</b-form-group>

							<!-- <b-form-group id="input-group-4">
								<b-form-checkbox-group v-model="form.checked" id="checkboxes-4">
									<b-form-checkbox value="me">Saya menyatakan bahwa data tersebut diatas adalah milik saya</b-form-checkbox>
								</b-form-checkbox-group>
							</b-form-group> -->
							<alert :status="status"/>
							<div class="clearfix">						
								<!--<b-button to="signin" class="float-left mr-2" type="reset" variant="warning">Already Have Account ?</b-button>
								<b-button class="float-left" type="reset" variant="danger">Clear Form</b-button>-->
								<b-button squared block variant="outline-primary" size="lg" type="submit" :disabled="loading||!passwordChecker"><b-spinner v-if="loading" small type="grow"></b-spinner> {{ $t("signup.btn") }}</b-button>
								<div v-html="$t('signup.agree')"></div>
							</div>

						</div>
					</b-form>
					<!-- <b-card class="mt-3" header="Form Data Result">
						<pre class="m-0">{{ form }}</pre>
					</b-card> -->
				</div>
				</div>
			</b-col>
			<div class="overlapButton" v-if="!showInvitation">
			<b-button squared block variant="primary" to="/signin" size="lg">{{ $t("signup.in") }}</b-button>		
			</div>
		</b-row>
	</b-container>
</template>

<script>
	import SvgImage from '../components/SvgImage.vue';
	import VuePhoneNumberInput from 'vue-phone-number-input';
   	import Alert from '../components/Alert.vue';
	export default {
		data() {
			return {
				loading: false,
				form_: {
					phone:null
				},
				formOtp: {
					otpCode: null
				},
				formOtpStatus: {
					otpCode: {
						state: null
					}
				},
				form: {
					ptmmEmail: '',
					ptmmFullName: '',
					ptmmGender: null,
					ptmmPassword: null,
					ptmmPhone: null,
					ptmmLanguage: 1
				},
				formStatus: {
					ptmmEmail: {
						state: null,
						message: null
					},
					ptmmFullName: {
						state: null,
						message: null
					},
					ptmmGender: {
						state: null,
						message: null
					},
					ptmmPassword: {
						state: null,
						message: null
					},
					ptmmPhone: {
						state: null,
						message: null
					},
				},
				validation : null,
				gender: [
					{ text: '--- Select ---', value: null },
					{ text: 'Male', value: 1 },
					{ text: 'Female', value: 2 },
				],
				languages: [
					{ text: 'English', value: 1 },
					{ text: 'Indonesia', value: 2 },
				],
				showForm: false,
				showOtp:false,
				passwordVisible:false,
				password:'',
				checkPassword:'',
				rules: [
					{ message:"One lowercase letter required", regex:/[a-z]+/ },
					{ message:"One uppercase letter required",  regex:/[A-Z]+/ },
					{ message:"8 characters minimum", regex:/.{8,}/ },
					{ message:"One number required", regex:/[0-9]+/ }
				],
				submitted:false,
				status: null,
				emailChecked: false,
				checkingEmail: false,
				showCheckButton: true,
				emailInUSe: false,
				resendingEmail: false,
				showInvitation: false,
				invitationSent: false
			}
		},
		mounted() {
			this.initialFormStatus = JSON.stringify(this.formStatus);
			this.init();
		},
		components : {
			VuePhoneNumberInput,
			Alert,
			SvgImage
		},
		methods: {
			useOldData(){
				// console.log(this.$router.currentRoute.query);
				this.$store.dispatch('SETUPPASSWORD', {data:{email:this.$router.currentRoute.query.email}})
					.then(s=>{
						this.invitationSent = true;
					})
			},
			daleteOldData(){
				// console.log(this.$router.currentRoute.query);
				this.$store.dispatch('REJECTINVITATION', {code:this.$router.currentRoute.query.code})
					.then(s=>{
						this.$router.push({path: '/signin'});
						// this.invitationSent = true;
					})
					.catch(err=>{
						if (err.response){
							this.status = err.response;
						}
						// this.$router.push({path: '/signin'});
					})
			},
			checkEmail(){
				var emailToCheck = this.form.ptmmEmail;
				console.log('do check email : ', emailToCheck);
				var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
				if (emailRegex.test(emailToCheck)){
					this.formStatus.ptmmEmail.state = null;
					this.formStatus.ptmmEmail.message = '';
					this.checkingEmail = true;
					this.$store.dispatch('CHECKEMAIL', {data:{email:emailToCheck}})
						.then((emailCheckingOut) =>{
							this.checkingEmail = false;
							console.log('A: ', emailCheckingOut);
							this.formStatus.ptmmEmail.state = true;
							this.formStatus.ptmmEmail.message = "Please continue to create your account.";
							this.showCheckButton = false;
							this.emailChecked = true;
							this.emailInUSe = false;
						})
						.catch(err => {
							this.checkingEmail = false;
							console.log('B: ', err.response);
							this.formStatus.ptmmEmail.state = false;
							if (err.response){							
								this.formStatus.ptmmEmail.message = err.response.data.status.error.message;
								this.emailInUSe = true;
							} else {
								this.formStatus.ptmmEmail.message = "Network Error check your internet connection.";
							}
							// this.parseError(err);
						})
				} else {
					this.formStatus.ptmmEmail.state = false;
					this.formStatus.ptmmEmail.message = 'E-mail format is invalid. Please try again.';
				}
				// console.log('email changed... ', emailRegex.test(emailToCheck), this.formStatus.ptmmEmail.state);
			},
			resendVerificationEmail(){
				var emailToResend = this.form.ptmmEmail;
				this.resendingEmail = true;
				this.$store.dispatch('RESENDVERIFICATIONEMAIL', {data:{email:emailToResend}})
					.then((emailResendOut) =>{
						this.resendingEmail = false;
						this.$router.push('/signup/otp')
						this.init();
						console.log('A: ', emailResendOut);
						// this.formStatus.ptmmEmail.state = true;
						// this.formStatus.ptmmEmail.message = "Looks good please proceed...";
						// this.showCheckButton = false;
						// this.emailChecked = true;
					})
					.catch(err => {
						this.resendingEmail = false;
						console.log('Email resend error: ', err);
						// this.formStatus.ptmmEmail.state = false;
						// this.formStatus.ptmmEmail.message = err.response.data.status.error.message;
						// this.emailInUSe = true;
						// this.parseError(err);
					})
				console.log('Resend verification to : ', emailToResend);
			},
			emailChanged(e){
				this.checkEmail();
			},
			init(){
				if (this.$router.currentRoute.params&&this.$router.currentRoute.params.action){
					switch(this.$router.currentRoute.params.action) {
						case 'otp':
							this.showOtp = true;
							this.showForm = false;
							if (this.$router.currentRoute.query){
								this.formOtp.otpCode = this.$router.currentRoute.query.code;
								this.onOtp();
							}
							// code block
						break;
						case 'invitation':
							this.showForm = false;
							this.showInvitation = true;
							// if (this.$router.currentRoute.query){
							// 	this.formOtp.otpCode = this.$router.currentRoute.query.code;
							// 	this.onOtp();
							// }
							// code block
						break;
						default:
							this.showForm = true;
							// code block
					}				
					console.log(this.$router.currentRoute.params, this.$router.currentRoute.query);
				} else {
					this.showForm = true;
				}
			},
			parseError(err){
				if (err.response&&err.response.data&&err.response.data.status&&err.response.data.status.error){
					console.log('E1: ', err.response.data.status.error)
					console.log('E2: ', err.response.data.status.error.errors)
					if (err.response.data.status.error.errors&&err.response.data.status.error.errors.length > 0){
						err.response.data.status.error.errors.forEach((errors)=>{
							console.log('E3: ', errors);
							if (Array.isArray(errors)){
								errors.forEach((error)=>{
									console.log('E4: ', error);	
									this.formStatus[error.field].state = false;
									this.formStatus[error.field].message = error.message;
								})
							}
						})
					}
				}
			},
			phoneUpdated(evt){
				this.form.ptmmPhone = evt.e164;
			},
			onSubmit(evt) {
				evt.preventDefault()
				if (this.passwordValidation.valid){
					this.loading = true;
					console.log('Do signup... ', this.form);
					this.$store.dispatch('SIGNUP', {data:this.form})
						.then((signUp) =>{
							this.loading = false;
							console.log(signUp)
							this.$router.push('/signup/otp')
							this.init();
						})
						.catch(err => {
							this.parseError(err);
							if (err.response){
								this.status = err.response;
							}
							this.loading = false;
						})
				}
			},
			onOtp(evt) {
				if (evt){
					evt.preventDefault()
				}
				if (this.formOtp.otpCode){				
					this.loading = true;
					console.log('Do signup... ', this.formOtp);
					this.$store.dispatch('VERIFICATION', {data:this.formOtp})
						.then((signUp) =>{
							this.loading = false;
							console.log('A: ', signUp);
							if (signUp.data.status=='OK'){
								// this.showOtp = false;
								console.log('B: ',signUp)
								this.$router.push({path: '/signin', query: { success: true }});
								this.status = null;
							}
						})
						.catch(err => {
							// this.parseError(err);
							// this.$router.push({path: '/signin', query: { success: true }});
							if (err.response){
								this.status = err.response;
							} else {
								this.status = {data:{status:{error:{message:'Verification failed, please report this problem to info@borobudurmarathon.com'}}}}
							}
							this.loading = false;
						})
				}
			},
			resendOtp(){

			},
			onReset(evt) {
				evt.preventDefault()
				// Reset our form values
				this.form.ptmmEmail= ''
				this.form.ptmmFullName= ''
				this.form.ptmmGender= null
				this.form.ptmmPhone= null
				this.form.ptmmPassword= ''
				this.checkPassword= ''
				this.formStatus = JSON.parse(this.initialFormStatus);
				// Trick to reset/clear native browser form validation state
				this.showForm = false
				this.status = null
				this.$nextTick(() => {
					this.showForm = true
				})
			},
			togglePasswordVisibility () {
				this.passwordVisible = !this.passwordVisible
			},
		},
		computed: {
			emailState(){
				return {
					state : this.formStatus.ptmmEmail.state,
					message : this.formStatus.ptmmEmail.message
				}
			},
			resetPasswords () {
				this.form.ptmmPassword = ''
				this.checkPassword = ''
			},
			passwordChecker(){
				if (this.form.ptmmPassword){
					if (this.passwordsFilled&&this.passwordValidation.valid&&!this.notSamePasswords){
						return true
					} else {
						return false
					}
					// return !this.notSamePasswords
				}
			},
			notSamePasswords () {
				if (this.passwordsFilled) {
					return (this.form.ptmmPassword !== this.checkPassword)
				} else {
					return false
				}
			},
			passwordsFilled () {
				return (this.form.ptmmPassword !== '' && this.checkPassword !== '')
			},
			passwordValidation () {
				let errors = []
				for (let condition of this.rules) {
					if (!condition.regex.test(this.form.ptmmPassword)) {
						errors.push(condition.message)
					}
				}
				if (errors.length === 0) {
					return { valid:true, errors }
				} else {
					return { valid:false, errors }
				}
			}
		}
	}
</script>




// WEBPACK FOOTER //
// SignupView.vue